// checklist.directive.ts
import {
  Directive, Input, Output, EventEmitter, HostListener, OnInit, OnChanges, DoCheck, SimpleChanges, ElementRef, Renderer2
} from '@angular/core';

@Directive({
  selector: '[appChecklist]'
})
export class ChecklistDirective implements OnInit, OnChanges, DoCheck {
  @Input('appChecklist') checklist: any[] = [];
  @Input() checklistValue: any;

  @Output() checklistChange = new EventEmitter<any[]>();
  @Output('appChecklistChange') appChecklistChange = new EventEmitter<any[]>();

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnInit() {
    this.setChecked(this.isChecked());
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.checklist || changes.checklistValue) {
      this.setChecked(this.isChecked());
    }
  }

  ngDoCheck() {
    this.setChecked(this.isChecked());
  }

  @HostListener('change', ['$event.target.checked'])
  onChange(checked: boolean) {
    const index = this.checklist.indexOf(this.checklistValue);
    if (checked) {
      if (index === -1) {
        this.checklist.push(this.checklistValue);
      }
      let checked =[{
        'RecordGUID': this.checklistValue,
        'checked': true
      }];
      this.checklistChange.emit(checked);
      this.appChecklistChange.emit(this.checklist);
    } else if (!checked) {
      if (index !== -1) {
        this.checklist.splice(index, 1);
      }
      let unchecked =[{
        'RecordGUID': this.checklistValue,
        'checked': false
      }];
      this.checklistChange.emit(unchecked);
      this.appChecklistChange.emit(this.checklist);
    }
    
  }

  private isChecked(): boolean {
    return this.checklist.includes(this.checklistValue);
  }

  private setChecked(value: boolean) {
    this.renderer.setProperty(this.el.nativeElement, 'checked', value);
  }
}
// checklist.directive.ts
